(() => {
  const formatMoney = (cents, currency) => {
    if (window.Shopify?.formatMoney && window.Shopify?.money_format) {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency }).format(Number(cents) / 100);
    } catch {
      return `${(Number(cents) / 100).toFixed(2)} ${currency}`;
    }
  };

  document.querySelectorAll('[data-corel-years]').forEach((picker) => {
    const form = picker.closest('form');
    if (!form) return;
    const variantInput = form.querySelector('[data-corel-variant-id]');
    const price = document.querySelector('[data-autodesk-price]');
    const addButton = form.querySelector('button[name="add"]');
    const gallery = document.querySelector('[data-corel-gallery]');
    const intro = document.querySelector('[data-corel-intro]');
    const description = document.querySelector('[data-corel-description]');
    const currency = price?.querySelector('small')?.textContent?.trim() || 'EUR';
    if (!variantInput || !window.Rdr21ProductSelection) return;
    const selection = window.Rdr21ProductSelection;
    const state = selection.guard(form, variantInput);
    const platform = form.querySelector('[data-corel-platform]');
    const platformChoices = [...form.querySelectorAll('[data-corel-platform-choice]')];
    let currentVariants = JSON.parse(picker.dataset.corelCurrentVariants || '[]');
    let variantTitle = picker.dataset.corelVariantTitle;
    let requestSequence = 0;

    const updateLinks = () => {
      picker.querySelectorAll('a[data-corel-product-url]').forEach((link) => {
        const variants = JSON.parse(link.dataset.corelVariants || '[]');
        const variant = variants.find((item) => item.title === variantTitle);
        if (variant) {
          link.href = selection.url(link.dataset.corelProductUrl, variant.id);
          link.removeAttribute('aria-disabled');
        } else link.setAttribute('aria-disabled', 'true');
      });
    };
    const updatePlatformChoices = () => {
      platformChoices.forEach((choice) => {
        const variant = currentVariants.find((item) => item.title === choice.dataset.corelVariantTitle);
        choice.disabled = !variant || !variant.available;
        choice.classList.toggle('is-selected', Boolean(variant && variant.title === variantTitle));
        choice.setAttribute('aria-pressed', variant && variant.title === variantTitle ? 'true' : 'false');
        const price = choice.querySelector('small');
        if (price && variant) price.textContent = formatMoney(variant.price, currency);
      });
    };
    updateLinks();
    updatePlatformChoices();

    const updatePrice = (variant) => {
      const current = price?.querySelector('[data-price-current]');
      const compare = price?.querySelector('[data-price-compare]');
      const saleDeadline = document.querySelector('[data-sale-deadline]');
      const compareValue = Number(variant.compare_at_price || 0);
      const hasCompare = compareValue > Number(variant.price);
      if (current) current.textContent = formatMoney(variant.price, currency);
      if (compare) {
        compare.textContent = hasCompare ? formatMoney(compareValue, currency) : '';
        compare.hidden = !hasCompare;
      }
      if (saleDeadline) saleDeadline.hidden = !hasCompare;
    };

    const updateGallery = (product) => {
      if (!gallery || !Array.isArray(product.images) || !product.images.length) return;
      gallery.replaceChildren(...product.images.map((src, index) => {
        const image = document.createElement('img');
        image.src = src;
        image.alt = product.title || '';
        image.width = 1200;
        image.loading = index === 0 ? 'eager' : 'lazy';
        return image;
      }));
    };

    const setSelection = (link) => {
      picker.querySelectorAll('[data-corel-product-json-url]').forEach((item) => {
        const selected = item === link;
        item.classList.toggle('is-selected', selected);
        if (selected) item.setAttribute('aria-current', 'true');
        else item.removeAttribute('aria-current');
      });
    };

    const loadProduct = async (link, historyMode = 'push') => {
      const sequence = ++requestSequence;
      state.busy(true);
      try {
        const response = await fetch(link.dataset.corelProductJsonUrl, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(12000) });
        if (!response.ok) throw new Error('Could not load the selected Corel version.');
        const product = await response.json();
        if (sequence !== requestSequence) return;
        if (decodeURIComponent(new URL(link.dataset.corelProductUrl, window.location.origin).pathname.replace(/\/$/, '').split('/').pop()) !== product.handle) throw new Error('Unexpected Corel product.');
        const requestedId = historyMode === 'none' ? new URL(window.location.href).searchParams.get('variant') : null;
        const variant = (product.variants || []).find((item) => requestedId ? String(item.id) === requestedId : item.title === variantTitle);
        if (!variant) {
          const error = new Error('The selected Corel platform does not exist.');
          error.variantMissing = true;
          throw error;
        }
  
        if (!state.commit(variant, product)) throw new Error('Invalid Corel variant data.');
        await state.refreshPaymentButton(link.dataset.corelProductUrl, product, variant);
        if (sequence !== requestSequence) return;
        variantTitle = variant.title;
        currentVariants = product.variants;
        if (platform) {
          platform.replaceChildren(...currentVariants.map((item) => {
            const option = document.createElement('option');
            option.value = String(item.id);
            option.textContent = item.title;
            option.selected = item.id === variant.id;
            option.disabled = !item.available;
            return option;
          }));
        }
        updatePlatformChoices();
        updatePrice(variant);
        updateGallery(product);
        if (intro) {
          intro.textContent = String(link.dataset.corelSummary || '').trim();
          intro.hidden = !intro.textContent;
        }
        if (description && typeof product.description === 'string') description.innerHTML = product.description;
        document.querySelectorAll('[data-corel-title]').forEach((node) => {
          node.textContent = String(link.dataset.corelProductTitle || product.title || '');
        });
        setSelection(link);
        updateLinks();
  
        const url = selection.url(link.dataset.corelProductUrl, variant.id);
        if (historyMode === 'push') window.history.pushState({ rdr21Corel: true }, '', url);
        if (historyMode === 'replace') window.history.replaceState({ rdr21Corel: true }, '', url);
        const title = String(link.dataset.corelProductTitle || product.title || '');
        document.title = `${title} | ${document.title.split(' | ').slice(1).join(' | ') || 'RDR Software'}`;
      } catch (error) {
        if (sequence !== requestSequence) return;
        state.block();
        throw error;
      } finally {
        if (sequence === requestSequence) state.busy(false);
      }
    };

    platform?.addEventListener('change', () => {
      const variant = currentVariants.find((item) => String(item.id) === platform.value);
      if (!state.commit(variant)) { state.block(); return; }
      variantTitle = variant.title;
      updatePrice(variant);
      updateLinks();
      updatePlatformChoices();
      window.history.replaceState({ rdr21Corel: true }, '', selection.url(window.location.pathname, variant.id));
    });

    platformChoices.forEach((choice) => {
      choice.addEventListener('click', () => {
        const variant = currentVariants.find((item) => item.title === choice.dataset.corelVariantTitle);
        if (!variant || !variant.available || !platform) return;
        platform.value = String(variant.id);
        platform.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });

    picker.addEventListener('click', (event) => {
      const link = event.target.closest('a[data-corel-product-json-url]');
      if (!link) return;
      if (link.getAttribute('aria-disabled') === 'true') { event.preventDefault(); return; }
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
      event.preventDefault();
      loadProduct(link).catch((error) => { if (!error.variantMissing) window.location.assign(link.href); });
    });

    window.addEventListener('popstate', () => {
      const path = window.location.pathname.replace(/\/$/, '');
      const link = [...picker.querySelectorAll('a[data-corel-product-json-url]')].find((item) => new URL(item.dataset.corelProductUrl, window.location.origin).pathname.replace(/\/$/, '') === path);
      if (link) loadProduct(link, 'none').catch(() => window.location.reload());
      else window.location.reload();
    });
  });

})();
